import loadScript from 'load-script';

const convertOpt = (option) => {
	let op = {};
	if (typeof option === 'string') {
		op = { name: option };
	}
	if (typeof option === 'object') {
		const newOption = {};
		const newOptionList = Object.keys(option);
		if (newOptionList.length > 0) {
			newOptionList.forEach((key) => {
				if (option[key] !== '' && option[key] !== undefined) newOption[key] = option[key];
			});
		}

		op = { ...newOption };
	}
	return op;
};

export function loadSdkScriptAsync() {
	return new Promise((resolve, reject) => {
		const isMobile = /Mobi|Android/i.test(navigator.userAgent);
		const url = isMobile ? 'https://ssl.nexon.com/s1/da/a2s.mobile.js' : 'https://ssl.nexon.com/s1/da/a2s.js';

		loadScript(url, (err) => {
			if (err) {
				console.error('SDK 로드 실패', err);
				reject(err);
			} else {
				resolve(window.$h); // SDK가 성공적으로 로드됨
			}
		});
	});
}

const a2s = {
	region: '',
	countryCode: '',
	sdkLoaded: false,
	isDirect: false,
	async init() {
		if (!this.sdkLoaded) {
			const res = await loadSdkScriptAsync(); // 위에서 만든 Promise 버전
			this.sdkLoaded = !!res.a2s;
		}
	},
	async view(object, option = {}) {
		this.init();
		let timeout;
		if (!window.$h || !window.$h.a2s) {
			timeout = setTimeout(() => a2s.view(object, option), 500);
			return;
		}

		const prefix = this.getPrefix();
		const op = {
			...option,
			logId: `${prefix}_${object}`,
			countryCode: this.region === 'global' ? this.countryCode : '',
		};

		const sendContentsLog = window.$h.a2s.sendContentsLog;

		clearTimeout(timeout);
		sendContentsLog(`${prefix}_${object}`, JSON.stringify(convertOpt(op)));
	},
	async click(object, option = {}) {
		this.init();
		let timeout;
		if (!window.$h || !window.$h.a2s) {
			timeout = setTimeout(() => a2s.click(object, option), 500);
			return;
		}

		const prefix = this.getPrefix();
		const op = {
			...option,
			logId: `${prefix}_${object}`,
			countryCode: this.region === 'global' ? this.countryCode : '',
		};

		const sendClickLog = window.$h.a2s.sendClickLog;

		clearTimeout(timeout);
		sendClickLog(`${prefix}_${object}`, JSON.stringify(convertOpt(op)));
	},
	setRegion(region) {
		this.region = region;
	},
	setCountryCode(countryCode) {
		this.countryCode = countryCode;
	},
	setIsDirect(isDirect) {
		this.isDirect = isDirect;
	},
	getPrefix() {
		const region = this.region === 'global' ? 'west' : this.region;
		const direct = this.isDirect ? 'direct' : 'buynx';
		return `${region}_${direct}`;
	},
};

export default {
	install(app) {
		app.prototype.$a2s = a2s;
	},
};
